/* ==========================================
   TA Ajax Cart + Mini Cart v2.0
   Torre Arka
========================================== */

(() => {
  if (window.TACartAjaxLoaded) return;
  window.TACartAjaxLoaded = true;

  const FORM_SELECTOR = '.ta-pcard__form';

  function getShopifyRoute(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${path}`.replace(/\/{2,}/g, '/');
  }

  function getCartSections(cartDrawer) {
    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function'
    ) {
      return cartDrawer
        .getSectionsToRender()
        .map((section) => section.id)
        .filter(Boolean);
    }

    return ['cart-icon-bubble'];
  }

  function createMiniCart() {
    let miniCart = document.querySelector('[data-ta-mini-cart]');

    if (miniCart) return miniCart;

    miniCart = document.createElement('aside');
    miniCart.className = 'ta-mini-cart';
    miniCart.setAttribute('data-ta-mini-cart', '');
    miniCart.setAttribute('role', 'status');
    miniCart.setAttribute('aria-live', 'polite');
    miniCart.setAttribute('aria-hidden', 'true');

    miniCart.innerHTML = `
      <button
        type="button"
        class="ta-mini-cart__close"
        aria-label="Cerrar notificación"
      >
        ×
      </button>

      <div class="ta-mini-cart__success">
        <span>✓</span>
        Agregado al carrito
      </div>

      <div class="ta-mini-cart__product">
        <div class="ta-mini-cart__media">
          <img
            class="ta-mini-cart__image"
            src=""
            alt=""
            width="88"
            height="88"
          >
        </div>

        <div class="ta-mini-cart__details">
          <strong class="ta-mini-cart__title"></strong>
          <span class="ta-mini-cart__price"></span>
        </div>
      </div>

      <div class="ta-mini-cart__actions">
        <button
          type="button"
          class="ta-mini-cart__continue"
        >
          Seguir comprando
        </button>

        <a
          class="ta-mini-cart__cart-link"
          href="${getShopifyRoute('cart')}"
        >
          Ir al carrito
        </a>
      </div>
    `;

    document.body.appendChild(miniCart);

    const closeButton = miniCart.querySelector('.ta-mini-cart__close');
    const continueButton = miniCart.querySelector(
      '.ta-mini-cart__continue'
    );

    closeButton.addEventListener('click', hideMiniCart);
    continueButton.addEventListener('click', hideMiniCart);

    return miniCart;
  }

  let miniCartTimer;

  function showMiniCart(button) {
    const miniCart = createMiniCart();

    const image = miniCart.querySelector('.ta-mini-cart__image');
    const media = miniCart.querySelector('.ta-mini-cart__media');
    const title = miniCart.querySelector('.ta-mini-cart__title');
    const price = miniCart.querySelector('.ta-mini-cart__price');

    title.textContent =
      button.dataset.productTitle || 'Producto agregado';

    price.textContent =
      button.dataset.productPrice || '';

    if (button.dataset.productImage) {
      image.src = button.dataset.productImage;
      image.alt = button.dataset.productTitle || '';
      media.hidden = false;
    } else {
      image.removeAttribute('src');
      image.alt = '';
      media.hidden = true;
    }

    const cartLink = miniCart.querySelector('.ta-mini-cart__cart-link');
    cartLink.href = getShopifyRoute('cart');

    window.clearTimeout(miniCartTimer);

    miniCart.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(() => {
      miniCart.classList.add('is-visible');
    });

    miniCartTimer = window.setTimeout(() => {
      hideMiniCart();
    }, 5500);
  }

  function hideMiniCart() {
    const miniCart = document.querySelector('[data-ta-mini-cart]');

    if (!miniCart) return;

    window.clearTimeout(miniCartTimer);
    miniCart.classList.remove('is-visible');
    miniCart.setAttribute('aria-hidden', 'true');
  }

  async function updateCartBubbleFallback() {
    try {
      const response = await fetch(getShopifyRoute('cart.js'), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const bubble = document.querySelector('#cart-icon-bubble');

      if (!bubble) return;

      let countElement = bubble.querySelector('.cart-count-bubble');

      if (cart.item_count <= 0) {
        countElement?.remove();
        return;
      }

      if (!countElement) {
        countElement = document.createElement('div');
        countElement.className = 'cart-count-bubble';
        countElement.innerHTML = `
          <span aria-hidden="true"></span>
          <span class="visually-hidden"></span>
        `;
        bubble.appendChild(countElement);
      }

      const visibleCount = countElement.querySelector(
        'span[aria-hidden="true"]'
      );

      const accessibleCount = countElement.querySelector(
        '.visually-hidden'
      );

      if (visibleCount) {
        visibleCount.textContent = cart.item_count;
      }

      if (accessibleCount) {
        accessibleCount.textContent =
          `${cart.item_count} artículos en el carrito`;
      }
    } catch (error) {
      console.error(
        'TA Cart: no se pudo actualizar el contador.',
        error
      );
    }
  }

  function restoreButton(button, originalText) {
    window.setTimeout(() => {
      button.classList.remove('is-success', 'is-error');
      button.textContent = originalText;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }, 1800);
  }

  async function addProduct(form) {
    const button = form.querySelector(
      '.ta-pcard__action--cart'
    );

    if (!button || button.disabled) return;

    const originalText = button.textContent.trim();
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = getCartSections(cartDrawer);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-success', 'is-error');
    button.textContent = 'Agregando…';

    try {
      const formData = new FormData(form);

      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append(
          'sections_url',
          `${window.location.pathname}${window.location.search}`
        );
      }

      const response = await fetch(
        getShopifyRoute('cart/add.js'),
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'No se pudo agregar el producto.'
        );
      }

      button.classList.add('is-success');
      button.textContent = 'Agregado ✓';

      if (
        cartDrawer &&
        typeof cartDrawer.renderContents === 'function' &&
        result.sections
      ) {
        cartDrawer.renderContents(result);
      } else {
        await updateCartBubbleFallback();
      }

      showMiniCart(button);

      document.dispatchEvent(
        new CustomEvent('ta:cart-added', {
          detail: {
            product: result,
            form
          }
        })
      );
    } catch (error) {
      console.error('TA Cart:', error);

      button.classList.add('is-error');
      button.textContent = 'Intenta otra vez';
    } finally {
      restoreButton(button, originalText);
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(FORM_SELECTOR);

    if (!form) return;

    event.preventDefault();
    addProduct(form);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      hideMiniCart();
    }
  });
})();